import { Injectable } from '@angular/core';


import $ from 'jquery';
import moment from 'moment';
import { cloneDeep } from "lodash";

import { ContextFactory } from '@shared/factories/context/context.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { AppLanguageFactory } from '@shared/factories/app-language/app-language.factory';
import { ActivatedRoute, Router } from '@angular/router';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { StateManagementFactory } from '@shared/factories/state-management/state-management.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { PrimeNGConfig } from 'primeng/api';
import { ConnectedOverlayScrollHandler } from 'primeng/dom';
import { DropdownsOpenFactory } from '@shared/factories/dropdowns-open/dropdowns-open.factory';

@Injectable({
  providedIn: 'root'
})
export class CommonUtilsService {
  constructor(private primeConfig: PrimeNGConfig,
    public context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private appLanguage: AppLanguageFactory,
    private translate: AfTranslateFactory,
    private customLanding: CustomLandingFactory,
    private route: ActivatedRoute,
    private userPermisions: UserPermisionsFactory,
    private stateManagement: StateManagementFactory,
    private router: Router,
    private dropdownsOpenFactory: DropdownsOpenFactory) { }

    deleteElement(item:any, list:any, prop:string){
      let findIndex = list.findIndex((listItem: any)=>{return listItem[prop] === item[prop]});
      list.splice(findIndex, 1);
      return this.createNewArray(list);
    }

    createNewArray(list:any){
      let newList:any = [];
      list.forEach((item:any) => {
        let newItem: any = {}
        for (let [key, value] of Object.entries(item)) {
          newItem[key] = value;
        }
        newList.push(newItem);
      });
      return newList;
    }

    replaceElement(item: any, list: any, prop: string, newItem: object){
      let findIndex = list.findIndex((listItem: any)=>{return listItem[prop] === item[prop]});
      list.splice(findIndex, 1, newItem);
      return list;
    }

    replaceElementTree(item:any, list:any, prop:string){
      for(let i = 0; i < list.length; i++){
        if( item[prop] ===  list[i][prop]){
          list.splice(i, 1, item);
          break;
        }
        if(list[i].children && list[i].children.length){
          this.replaceElementTree(item, list[i].children, prop);
        }
      }
      return list;
    }

    addElement(list: any, newItem: object){
      return list.splice(list.length, 1, newItem);
    }

    editList(list: any, id: any, name: string){
      list.forEach((element: any) => {
        element.listValueId = element[id];
        element.text = element[name]
      });
      return list
    }

    createId(){
      // let word = '';
      // let firstWord='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      // let myIdWord='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
      // for(let i = 0; i < 15; i++){
      //     if(i === 0){
      //       word += firstWord.charAt(Math.floor(Math.random()* firstWord.length));
      //     }else{
      //       word += myIdWord.charAt(Math.floor(Math.random()* myIdWord.length));
      //     }
      // }
      // return word;
      let alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let firstCharacter = alphabet.charAt(Math.floor(Math.random()* alphabet.length));
      let dateString = Date.now().toString(36);
      let randomness = Math.random().toString(36).substring(2);
      return firstCharacter + dateString + randomness;
    }

    createNumberId(){
      // let number = Math.floor(Math.random() * Math.random() * 100000);
      let number = Date.now();
      return number;
    }

    configureFilials(list: any){
      list.forEach((child: any) => {
        if(child.parentId){
          this.findParent(child, list);
        }
      });
      return list;
    }

    findParent(child: any, list: any){
      list.forEach((element:any) => {
        if(child.parentId === element.clientId){
          child.parentName = element.parentId? element.parentName : element.name;
          element.children?element.children.push(child) : element.children = [child];
        }
      });
    }

    extractToArray(property: any, array: any, id:any){
      return array.filter((item:any)=> item[id] === property)[0];
        }

    extractInnerHTML(message:any){
      let temporalDiv = document.createElement("div");
      temporalDiv.innerHTML = message;
      let innerHTML = temporalDiv.textContent || temporalDiv.innerText || "";
      return innerHTML;
    }

    checkIsIntegerNumber(text: string){
      let numbers = '0123456789';
      for(let i = 0; i < text.length; i++){
          if(numbers.indexOf(text.charAt(i),0) === -1){
              return false;
          }
      }
      return true;
    }

    checkRequiredFields(concept:any, userPublic:any){
      let errors:any ={
        commonErrors: 0,
        blockedErrors: 0,
        validateErrors: 0
      }
      let isLanding: Boolean = this.customLanding.isLanding();
      if(this.globalCfg.skin === 'uk-steel-blue' && !isLanding){
        return errors;
      }
      concept.fieldContainers.forEach((fieldContainer: any) => {
        if(!fieldContainer.hidden){
          fieldContainer.fields.forEach((fieldContainerField: any) => {
            if(concept.errorInForm?.length && fieldContainerField.errorInForm){
              fieldContainerField.error = true;
              errors.validateErrors++;
            }else if(!concept.errorInForm?.length && concept.hasBlockerFields && !isLanding && fieldContainerField.blocker && this.checkField(fieldContainerField)){
              fieldContainerField.error = true;
              fieldContainerField.blockError = true;
              errors.blockedErrors++;
            }
          })
          fieldContainer.subContainers.forEach((subContainer: any) => {
            subContainer.fields.forEach((subcontainerField: any) => {
              if(concept.errorInForm?.length && subcontainerField.errorInForm){
                subcontainerField.error = true;
                errors.validateErrors++;
              }else if(!concept.errorInForm?.length && concept.hasBlockerFields && !isLanding && subcontainerField.blocker && this.checkField(subcontainerField)){
                subcontainerField.error = true;
                subcontainerField.blockError = true;
                errors.blockedErrors++;
              }
            })
          })
        }
      })
      if(!errors.validateErrors && !errors.blockedErrors){
        errors.commonErrors =  this.checkCommonErrors(concept, userPublic)
      }
      return errors;
    }

    checkMultipleSubcontainer(subcontainer: any, concept: any){
      let errorsSubcontainer = 0;
      let subContainerMultiple = concept.subContainerMultiple.get(subcontainer.fieldContainerId);
      subContainerMultiple.forEach((subContainer: any) => {
        subContainer.fields.forEach((field:any) => {
          if(field.show){
            field.error = field.fieldContentTypeId === 'emai' || field.fieldContentTypeId === 'addr'?field.error:false;
            if((!field.notCurrentValue && field.required) && this.checkField(field)){
              field.error = true;
              errorsSubcontainer++;
            }
        }
        });
      });
      return errorsSubcontainer;
    }

    checkField(field:any):any{
      if(field.noEditable){
        return false;
      }else if(field.evaluatedValue){
        switch(field.fieldTypeId){
          case 'rich':
            return (field.evaluatedValue.nvarcharValue === null || field.evaluatedValue.nvarcharValue === '');
          case 'list':
          case 'listp':
            return !field.multiple? (field.evaluatedValue.floatvalue === null): (field.evaluatedValue.nvarcharValue == null || field.evaluatedValue.nvarcharValue.trim() == '')
          case 'user':
              return field.evaluatedValue.nvarcharValue === null;
          case 'date':
              return field.evaluatedValue.datetimeValue === null;
          case 'num':
          case 'money':
            if(!(field.evaluatedValue.floatvalue === null || field.evaluatedValue.floatvalue === '')){
              if(((field.minValue || field.minValue === 0) && field.evaluatedValue.floatvalue < field.minValue) || ((field.maxValue || field.maxValue === 0) && field.evaluatedValue.floatvalue > field.maxValue)){
                return true;
              }
              return false;
            }
            return true;
          case 'l-co':
            return field.multiple? (field.evaluatedValue.nvarcharValue === null || field.evaluatedValue.nvarcharValue === '') : (field.evaluatedValue.floatvalue === null || field.evaluatedValue.floatvalue === '');
          case 'rich':
              return (field.description == null || field.description.trim() === '');
          case 'text':
              if(field.fieldContentTypeId === 'emai' && field.evaluatedValue.nvarcharValue){
                return !(this.validateMail(field.evaluatedValue.nvarcharValue));
              }
              if(field.evaluatedValue.nvarcharValue === undefined){
                  field.evaluatedValue.nvarcharValue = null;
              }
              return (field.evaluatedValue.nvarcharValue === null || field.evaluatedValue.nvarcharValue === '');
          case 'file':
              return !(field.evaluatedValue && field.evaluatedValue.documents && field.evaluatedValue.documents.length)
          case 'bool':
          case 'boolp':
              return field.evaluatedValue.bitValue === null;
          case 'txchk':
              return field.evaluatedValue.bitValue === null || field.evaluatedValue.bitValue === false;
          default:
              return true;
        }
      }else{
        return true;
      }
    }

    checkCommonErrors(concept:any, userPublic:any){
      let errors:number = 0;
      let isLanding: Boolean = this.customLanding.isLanding();
      for(let i = 0; i < concept.fieldContainers.length; i++){
        let fieldContainer = concept.fieldContainers[i];
        if(!fieldContainer.hidden){
          for(let j = 0; j < fieldContainer.fields.length; j++){
            let fieldContainerField = fieldContainer.fields[j];
            let hiddenInLanding = fieldContainer.hiddenInLanding || fieldContainerField.hiddenInLanding;
            fieldContainerField.error = fieldContainerField.fieldContentTypeId === 'emai' || fieldContainerField.fieldContentTypeId === 'addr'?fieldContainerField.error:false;
            if (!hiddenInLanding && !((isLanding && userPublic && (fieldContainer.private || fieldContainerField.private)) || !fieldContainer.show || !fieldContainerField.show || fieldContainerField.hidden)) {
              if (!fieldContainerField.noEditable && (!fieldContainerField.notCurrentValue && fieldContainerField.required) && this.checkField(fieldContainerField)) {
                fieldContainerField.error = true;
                errors++;
              }
            }
          }
          for(let k = 0; k < fieldContainer.subContainers.length; k++){
            let  subContainer = fieldContainer.subContainers[k];
            for(let l = 0; l < subContainer.fields.length; l++){
              let subcontainerField = subContainer.fields[l];
              let subHiddenInLanding = fieldContainer.hiddenInLanding || subcontainerField.hiddenInLanding || subcontainerField.hiddenInLanding;
              subcontainerField.error = subcontainerField.fieldContentTypeId === 'emai' || subcontainerField.fieldContentTypeId === 'addr'?subcontainerField.error:false;
              if(!subHiddenInLanding && !((isLanding && userPublic && (fieldContainer.private || subcontainerField.private || subContainer.private)) || !fieldContainer.show || !subContainer.show || subcontainerField.hidden)){
                if(!subcontainerField.noEditable && (!subcontainerField.notCurrentValue && subcontainerField.required) && subContainer.multiple){
                  errors += this.checkMultipleSubcontainer(subContainer, concept);
                } else if (!subcontainerField.noEditable && (!subcontainerField.notCurrentValue && subcontainerField.required) && this.checkField(subcontainerField) && subcontainerField.show){
                  subcontainerField.error = true;
                  errors++;
                }
              }
            }
          }
        }
      }
      return errors;
    }

    cleanFieldEvaluatedValue(field: any, concept: any){
      if(field.evaluatedValue && field.fieldTypeId !== 'rich'){
        let fieldValue = field.defaultValue?field.defaultValue:null;
        field.evaluatedValue.default = fieldValue;
        field.evaluatedValue.isModified = true;
        field.error = false;
        switch(field.fieldTypeId){
          case 'date':
            field.evaluatedValue.datetimeValue = fieldValue;
            field.errorInDateLock = false;
            field.errorInForm = false;
            this.deleteConceptErrorForm(field, concept);
            break;
          case 'file':
            field.evaluatedValue.documents = [];
            break;
          case 'bool':
          case 'boolp':
          case 'txchk':
            field.evaluatedValue.bitValue = fieldValue;
            break;
          case 'text':
          case 'user':
            field.evaluatedValue.nvarcharValue = fieldValue;
            if(field.fieldTypeFrontId === 'emai' || field.fieldTypeFrontId === 'link'){
                field.errorInForm = false;
                this.deleteConceptErrorForm(field, concept);
            }
            break;
          case 'num':
          case 'money':
            field.evaluatedValue.floatvalue = fieldValue;
            break;
          case 'list':
          case 'listp':
          case 'l-fo':
          case 'l-co':
          case 'l-sg':
            let value:any = !field.multiple? 'floatvalue' : 'nvarcharValue';
            field.evaluatedValue[value] = fieldValue;
            field.listValues.forEach((element:any) => {
              delete element.selected;
            });
            break;
          case 'tree':
          case 'treep':
            let valueTree:any = !field.multiple? 'floatvalue' : 'nvarcharValue';
            field.evaluatedValue[valueTree] = fieldValue;
            this.resetAllListValues(field.listValues);
            break;
          default:
            field.evaluatedValue.nvarcharValue = fieldValue;
            field.evaluatedValue.floatvalue = fieldValue;
            break;
        }
      }
    }

    resetAllListValues(list: any){
      list.forEach((listValue: any)=>{
        delete listValue.selected;
        if(listValue.children?.length){
          this.resetAllListValues(listValue.children);
        }
      })
    }

    configureConceptErrorForm(field: any, concept: any){
      if(field.errorInForm){
          if(!concept.errorInForm?.length){
              concept.errorInForm = [];
              concept.errorInForm.push(field);
          }else if(!this.existsFieldErrorToConcept(field, concept)){
              concept.errorInForm.push(field);
          }
      }else if(concept.errorInForm?.length){
          this.deleteConceptErrorForm(field, concept);
      }
    }

    deleteConceptErrorForm(field: any, concept: any){
      for(let i = concept.errorInForm?.length-1; i >= 0; i--){
          let errorInForm = concept.errorInForm[i];
          if(errorInForm.fieldId === field.fieldId){
              concept.errorInForm.splice(i, 1);
              break;
          }
      }
    }

    existsFieldErrorToConcept(field: any, concept: any){
      for(let i = 0; i < concept.errorInForm?.length; i++){
          let errorInForm = concept.errorInForm[i];
          if(errorInForm.fieldId === field.field){
              return true;
          }
      }
      return false;
    }

    validateField(field: any):boolean {
      if(field.fieldTypeId === 'text'){
        if(field.evaluatedValue){
          let value = field.evaluatedValue.nvarcharValue;
          if (value != null && value.trim() != '' && field.fieldContentTypeId === 'addr') {
              return this.validateURL(value);
          }
        }
        return true
      }
      return true;
    }

    // validateMail(mail: string): boolean{
    //   if(mail?.length <= 320){
    //     // return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(mail);
    //             //Nombre del destinatario                                      //@//Nombre dominio//.//dominio
    //     return /^([^<>()\[\]\\À-ÿ,;:\s@"]{1,63})(([^<>()\[\]\\À-ÿ.,;:\s@"]){1})@(([A-z\-0-9]+\.)+([A-z]{2,}))+$/.test(mail);
    //   }else{
    //     return false;
    //   }
    // }

    validateMail(mail: string): boolean {
      if (!mail || mail.length > 320) {
        return false;
      }
      // Bloquea puntos ...
      if (mail.includes('..')) {
        return false;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
      return emailRegex.test(mail);
    }

    validateNoSpecialCharacters(text: string):boolean {
      // return new RegExp("[A-Za-zÀ-ȕ0-9()-_. ]+$").test(text);
      let regex = new RegExp('[¨~#!%&¡¿{}´><`;:\|\·\$\^\?\\+]', 'gi');
      return !(regex.test(text));
    }

    validateURL(url:string):boolean {
      let urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
        '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locato
      return !!urlPattern.test(url);
    }

    getMobilePhoneList(list: any, type: any, type2: any): any{
      let listMobilePhone:any = [];
      list.forEach((contact:any) => {
        let phoneNumberSMS = '';
        phoneNumberSMS = this.checkMobilePhone(contact, type, type2);
        if(phoneNumberSMS !== ''){
          listMobilePhone.push(contact);
        }
      });
      return listMobilePhone;
    }

    checkMobilePhone(contact: any, type: any, type2: any){
      let regExpMobileSpain = new RegExp('^((\\+34|0034|34)?[-|\.]*(6|7[-|\.]*){1}([0-9][-|\.]*){8})$');
      let regExpMobileFrance = new RegExp('^((\\+33|0033|33)?[-|\.]*(0)?(6|7[-|\.]*){1}([0-9][-|\.]*){8})$');
      if(regExpMobileSpain.test(contact[type]) || regExpMobileFrance.test(contact[type]) || regExpMobileSpain.test(contact[type2]) || regExpMobileFrance.test(contact[type2])){
        contact.phoneNumberSMS = contact[type2];
        if(regExpMobileSpain.test(contact[type]) || regExpMobileFrance.test(contact[type])){
          contact.phoneNumberSMS = contact[type];
        }
        contact.phoneNumberSMS = contact.phoneNumberSMS.replace(/-/g,"");
        // contact.phoneNumberSMS = contact.phoneNumberSMS.replace(/\+/g,"");
        contact.phoneNumberSMS = contact.phoneNumberSMS.replace(/\./g,"");
        contact.phoneNumberSMS = contact.phoneNumberSMS.replace(/ /g,"");
        return contact.phoneNumberSMS;
      }
      return '';
    }

    configureReportRow(row: any, column:any, color: any=null){
      for(let i = 0; i < 29; i++){
        row['OFAFMVJfield'+i] ={
          key:'OFAFMVJ-42',
          value:'OFAFMVJ-42',
          displayWidth:0
        }
      }

      let acu = 0;
      for(let i = 0; i < column.length; i++){
        let showDependencies: boolean = false;
        if(column[i].fieldTypeId !== 'options'){
          let value: any = row[column[i].id];
          let elementsDependencies: any = [];
          if(column[i].isHTMLDependencies && value){
            let separatorDependencies: any = row[column[i].id].split(' ·');
            value = separatorDependencies[0];
            if(separatorDependencies.length > 1){
              let listDependencies: any = separatorDependencies[1].split('Dependencias: ')[1];
              if(listDependencies?.indexOf('|') !== -1){
                elementsDependencies = listDependencies.split('|');
              }else{
                elementsDependencies = [listDependencies];
              }
              showDependencies = true;
            }
          }
          row['OFAFMVJfield'+acu] = {
            key: column[i].id,
            value: value,
            displayWidth:column[i].displayWidth,
            fieldTypeId: column[i].fieldTypeId,
            progressColor: '',
            hasColor: false,
            hasOpacity: column[i].isHighLight,
            isHTMLDependencies: showDependencies,
            elementsDependencies: elementsDependencies,
            idUnique: this.createId()
          }
          if(column[i].id && color){
            this._getBackgroundColor(column[i], color, row['OFAFMVJfield'+acu], row);
          }
          acu++;
        }
      }
    }

    _getBackgroundColor(column: any, color: any, rowConfigurated: any, row: any){
      if(color[column.id] && color[column.id].charAt(0)==='#'){
        row[column.id + 'ProgressColor'] = color[column.id];
        rowConfigurated.progressColor = color[column.id];
        rowConfigurated.hasColor = true;
      }
    }

    setMomentLanguage(){
      let userLanguage: any = this.getLanguage()
      let language = userLanguage.split('-')[0]
      if(userLanguage.indexOf('nl-BE') !== -1){
        language = userLanguage.toLowerCase()
      }
      if(moment.locale() !== language){
        moment.updateLocale(language, {
          week: {
            dow: 1
          }
        });
      }
    }

    getLanguage(){
      let userLanguage: any = sessionStorage.getItem('selectLanguage');
      if(!userLanguage || userLanguage === "null"){
        userLanguage = (navigator.language);
        if(this.appLanguage?.languaje){
          userLanguage = this.appLanguage.languaje;
        }
      }
      return userLanguage;
    }

    configureLogos(data: any){
      data.logo = this.setLogo(data.logo, data.logo);
      data.logoFooter = this.setLogo(data.logoFooter, data.logo);
      data.logoHeader = this.setLogo(data.logoHeader, data.logo);
      data.logoOther = this.setLogo(data.logoOther, data.logo);
      return data;
    }

    setLogo(logo: any, globalLogo: any=null){
      let newLogo= logo;
      if(newLogo === null ){
        newLogo = globalLogo;
      }
      if(newLogo && newLogo.indexOf('data:image') === -1){
        return "data:image/png;base64," + newLogo;
      }
      return newLogo;
    }

    baseToFormdata(base64URI: string, type: string='ico'): any{
      if(base64URI){
        let binary = atob(base64URI.split(',')[1]);
        let array = [];
        for(let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        let imageType = type === 'ico'?'image/vnd.microsoft.icon':'image/jpeg'
        return new Blob([new Uint8Array(array)], {type: imageType});
      }
    }

    addDocumentToField(newDocument: any, fieldIdSelected: any, concept: any){
        loopAddDocument:
        for(let i = 0; i < concept.fieldContainers.length;i++){
            let container = concept.fieldContainers[i];
            for(let j = 0; j < container.fields.length;j++){
                let field = container.fields[j];
                if(field.fieldId === fieldIdSelected){
                    if(!field.evaluatedValue.documents){
                        field.evaluatedValue.documents = [];
                    }
                    field.evaluatedValue.documents.splice(field.evaluatedValue.documents.length, 0, newDocument);
                    this.addDisplayDataToField(field, newDocument);
                    break loopAddDocument;
                }
            }
            for(let k = 0; k < container.subContainers.length; k++){
                let subContainer = container.subContainers[k];
                for(let l = 0; l < subContainer.fields.length; l++){
                    let fieldSubcontainer = subContainer.fields[l];
                    if(fieldSubcontainer.fieldId === fieldIdSelected){
                        if(!fieldSubcontainer.evaluatedValue.documents){
                            fieldSubcontainer.evaluatedValue.documents = [];
                        }
                        fieldSubcontainer.evaluatedValue.documents.splice(fieldSubcontainer.evaluatedValue.documents.length, 0, newDocument);
                        this.addDisplayDataToField(fieldSubcontainer, newDocument);
                        break loopAddDocument;
                    }
                }
            }
        }
    }

    addDisplayDataToField(field: any, newDocument: any){
        let displayDataField = {
            id: newDocument.documentObjectId,
            value: newDocument.name
        }
        field.evaluatedValue.displayData.push(displayDataField);
    }

    deleteDocumentToField(deleteDocument:any, concept: any){
        loopDeleteDocument:
        for(let i = 0; i < concept.fieldContainers.length;i++){
            let container = concept.fieldContainers[i];
            for(let j = 0; j < container.fields.length;j++){
                let field = container.fields[j];
                if(field.evaluatedValue && field.evaluatedValue.documents){
                    for(let m = 0; m < field.evaluatedValue.documents.length;m++){
                        let documentField = field.evaluatedValue.documents[m];
                        if(documentField.documentObjectId === deleteDocument.documentObjectId){
                            field.evaluatedValue.documents.splice(m, 1);
                            break loopDeleteDocument;
                        }
                    }
                } else if (field.evaluatedValue && field.isVoiceRecord && field.newAddDocument && field.newAddDocument.documentObjectId === deleteDocument.documentObjectId) {
                  field.newAddDocument = {};
                  field.voiceRecordFile = undefined;
                  field.voiceRecordName = undefined;
                  container.fields[j] = cloneDeep(field)
                  break loopDeleteDocument;
                }
            }
            for(let k = 0; k < container.subContainers.length; k++){
                let subContainer = container.subContainers[k];
                for(let l = 0; l < subContainer.fields.length; l++){
                    let fieldSubcontainer = subContainer.fields[l];
                    if(fieldSubcontainer.evaluatedValue && fieldSubcontainer.evaluatedValue.documents){
                        for(let p = 0; p < fieldSubcontainer.evaluatedValue.documents.length;p++){
                            let documentField = fieldSubcontainer.evaluatedValue.documents[p];
                            if(documentField.documentObjectId === deleteDocument.documentObjectId){
                                fieldSubcontainer.evaluatedValue.documents.splice(p, 1);
                                break loopDeleteDocument;
                            }
                        }
                    }
                }
            }
        }
    }

    configureAvailableLanguages(availableLanguages: any){
      let languages:any = [];
      availableLanguages.forEach((selectLanguage: any) => {
        languages.push({
          listValueId: selectLanguage,
          text: this.selectTextRegion(selectLanguage),
          specific: this.selectSpecificTextRegion(selectLanguage),
          appLanguage: selectLanguage
        })
      });
      return languages;
    }

    selectTextRegion(selectLanguage: string){
      return this.translate.instant(selectLanguage.substring(3,5).toLowerCase() ==='be' && selectLanguage.substring(0,2).toLowerCase() ==='nl'? 'app-languages.be' : 'app-languages.' + selectLanguage.substring(0,2).toLowerCase());
    }

    selectSpecificTextRegion(selectLanguage: string){
      let specificText = selectLanguage[1] === 'GB'
                          || selectLanguage[1] === 'US'
                          || (selectLanguage[1] === 'BE' && selectLanguage[0] ==='fr')
                          || (selectLanguage[1] ==='ES' && selectLanguage[0] ==='ca')
                          || (selectLanguage[1] === 'ES' && selectLanguage[0] === 'eu')
                          || (selectLanguage[1] === 'ES' && selectLanguage[0] === 'gl');
      return this.translate.instant('app-languages.' + (specificText?selectLanguage[0]:selectLanguage.substring(0,2).toLowerCase())+'-native');
    }

    setProductList(productList: any){
      productList.forEach((product: any) => {
        let name = product.name;
        if(this.globalCfg.skin === 'steel-blue' && product.productId === 'blanqueo'){
          product.shortName = 'ML';
        }else{
          if(this.globalCfg.skin === 'dark-blue' || this.globalCfg.skin === 'gm-law'){
            let words = product.name.split(' ');
            if(words[0].toLowerCase() === 'centinela'){
                words.splice(0,1);
            }
            name = words.join(" ")
          }
          let secondName = name.substring(name.indexOf(" ")+1, name.length);
          let regExp = /[$%&@|<>#!¡¿?/\\()\{\}\[\]_.,;:'`´-]/;
          let shortName = name.charAt(0);
          let secondNameLetter = name.charAt(name.indexOf(" ")+1);
          if(name.indexOf(" ") === -1){
            secondNameLetter = name.charAt(1);
          }else if(secondName.indexOf(" ") === 1 && regExp.test(secondName.substring(0, secondName.indexOf(" ")))){
            secondNameLetter = secondName.charAt(secondName.indexOf(" ")+1);
          }
          product.shortName = (shortName + secondNameLetter).toUpperCase();
        }
      });

      productList.sort(this.orderProductList);
      return productList;
    }

    orderProductList(a: any, b: any) {
      return a.shortName > b.shortName ? 1 : a.shortName < b.shortName ? -1 : 0;
    }

    filterEvaluationByProduct(arrayToFilter: any, itemToFilter: any, isTask: boolean = false){
      let filterArray : any = [];
      if (arrayToFilter) {
        filterArray = arrayToFilter.filter((item: any)=>{
        return (itemToFilter && item.productId === itemToFilter.productId) || (isTask && item.productId === null)
        })
      }
      return filterArray;
    }

    filterEvaluationByClient(arrayToFilter: any, itemToFilter: any){
      return arrayToFilter.filter((item: any)=> (item.clientId === itemToFilter.clientId))
    }

    filterReportsByEvaluation(reports:any, filteredEvaluation:any){
      let filteredReports:any = [];
      if (filteredEvaluation != null && reports != null) {
        filteredEvaluation.forEach((filter:any) => {
          reports.forEach((report:any) => {
            if (filter.evaluationId === report.evaluationId) {
              filteredReports.push(report);
            }
          });
        });
      }
      return filteredReports;
    }

    setLocaleNumberFormat(numberLocale: any){
      let newValue = '';
      let maxDecimal = 0;
      let language = this.getLanguageNumber();
      if(typeof numberLocale === 'number') {
        let newNumber = numberLocale;
        maxDecimal = 3;
        return this.parseNumberToLocaleString(newNumber, maxDecimal, language);
      }
      newValue = numberLocale.replace(',','.');
      maxDecimal = this.maxDecimalsToNumber(newValue);
      return this.parseNumberToLocaleString(newValue, maxDecimal, language);
    }

    maxDecimalsToNumber(number:any){
      let numberString: string = number.toString();
      if(numberString.indexOf('.') !== -1){
        return numberString.substring(numberString.indexOf('.')+1,numberString.length).length;
      }
      return 0;
    }

    parseNumberToLocaleString(number: any, maxDecimal: any, language: any){
      if(maxDecimal){
        return parseFloat(number).toLocaleString(language, {maximumFractionDigits: maxDecimal});//minimumFractionDigits
      }else{
        return parseFloat(number).toLocaleString(language);
      }
    }

    getLanguageNumber(){
      return window.navigator.language === 'es-ES'?'ca':window.navigator.language;
    }

    replaceDecimals(value:any){
      let decimals: any =  (1000000.1).toLocaleString().substr((1000000.1).toLocaleString().lastIndexOf('1')-1,1);
      // let millar: any = (1000000.1).toLocaleString().substr((1000000.1).toLocaleString().indexOf('1')+1,1);
      if(decimals === ','){
        value = value.replaceAll('.','').replace(',','.');
      }else{
        value = value.replaceAll(',','');
      }
      return value;
    }

    getQuarters(){
      return {
        from: new Date(moment().startOf('quarter').format('MM-DD-YYYY')),
        to: new Date(moment().endOf('quarter').format('MM-DD-YYYY'))
      }
    }

    configureLoaderImg(){
      // switch(this.globalCfg.skin){
      //   case 'steel-blue':
      //   case 'uk-steel-blue':
      //     return '../assets/img/loader-steel-blue.gif';
      //   case 'icam-red':
      //     return '../assets/img/loader-icam.gif';
      //   case 'gm-law':
      //     return '../assets/img/loader.gif';
      //   default:
      //     return '../assets/img/loader.gif';
      // }
    }

    objectDeepCopy(obj: any) {
      return cloneDeep(obj);
    }

    configureAlertState(item: any){
      if(item.stepIsFinal || item.processingHours === null){
        item.alertState = '4-finish';
        item.colorAlert = 'grey';
      }else if(parseInt(item.processingHours) <= 24){
        item.alertState = '1-last-day';
        item.colorAlert = 'green';
      }else if(parseInt(item.processingHours) > 24 && parseInt(item.processingHours) <= 48){
        item.alertState = '2-two-days';
        item.colorAlert = 'yellow';
      }else if(parseInt(item.processingHours) > 48){
        item.alertState = '3-more-time';
        item.colorAlert = 'red';
      }
      return item;
    }

    convertShortDate(dateShort: any){
      let date = dateShort.split('/');
      return moment(date[1]+'-'+date[0]+'-'+date[2]);
    }

    configureCustomButtonsTiny(field: any, tinyMceOptions: any){
      tinyMceOptions.customButtons = [];
      if (field.bookmarksTag?.length) {
          let bookmarksTag = {
            type: 'bookmarksTag',
            list: field.bookmarksTag
          }
          tinyMceOptions.customButtons.push(bookmarksTag);
      }
      if (field.showSnippets) {
        // Snippet tag list
        tinyMceOptions.customButtons.push({
          type: 'snippetsTag',
          list: field.snippetsTag ?? []
        });
        // Add new snippet
        tinyMceOptions.customButtons.push({
          type: 'addNewFragment'
        });
      }
    }

    showTooltip(keyElement:string): boolean{
      let parent: any = $('#'+keyElement)? $('#'+keyElement).width() : 0;
      let child: any = $('#span-'+keyElement)? $('#span-'+keyElement).width() : 0;
      return (Math.round(child)>Math.round(parent));
    }

    showTooltipHeight(id:string = ''): boolean{
      return this.showMoreInfo(id);
    }

    showMoreInfo(id:string = ''): boolean{
      let element: any = document.getElementById(id);
      return (Math.round(element.scrollHeight)>Math.round(element.clientHeight));
    }

    jsonEncode(string: any) { // eslint-disable-line camelcase
      let escapeChars = [
          '\u0000-\u001f',
          '\u007f-\u009f',
          '\u00a1-\u00ff',
          '\u00ad',
          '\u0600-\u0604',
          '\u070f',
          '\u17b4',
          '\u17b5',
          '\u200c-\u200f',
          '\u2028-\u202f',
          '\u2060-\u206f',
          '\ufeff',
          '\ufff0-\uffff'
      ].join('');
      let meta: any = {
          // table of character substitutions
          '\b': '\\b',
          '\t': '\\t',
          '\n': '\\n',
          '\f': '\\f',
          '\r': '\\r',
          '"': '\\"',
          '\\': '\\\\'
      };
      let escapable = new RegExp('[\\"' + escapeChars + ']', 'g');
      escapable.lastIndex = 0;
      return escapable.test(string) ? string.replace(escapable,(a:any)=>{
          let c = meta[a]
          return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0)
              .toString(16))
              .slice(-4)
        }):string;
    }

    // filterItemsLength(list:any, search:string, listToFilter:any, unique:string=''){
    //   return 5;
    // }

    getColors(item: any, type:string=''): unknown {
      switch(type){
        case 'icon-filter-list':
            return this.progressColors(item);
        default:
            return this.defaultColors(item);
      }
    }

    defaultColors(item: any){
      switch(item){
          case 3: //'En progreso'
          case 'En proceso':
          case 'progress':
              return "yellow";

          case 2: //'Stand by'
          case 'Descartada':
          case 'Atrasado':
              return "orange";

          case 1: //'Abierta'
          case 'Sin empezar':
              return "red";

          case 6://'Cerrada sin resolver'
              return "brown";

          case 5://'Cerrada'
              return "grey";

          default:
              return "green";
      }
    }

    progressColors(item:any){
      switch(item){
        case 'started':
        case '3-more-time':
          return 'red';
        case 'in-progress':
        case '2-two-days':
          return 'yellow';
        case 'advanced':
        case '1-last-day':
          return 'green';
        default:
          return 'grey';
      }
    }

    calculeRatio(colorCheck: string) {
      // leer los colores y transformarlos a RGB
      const colorWhite: any = { r: 255, g: 255, b: 255 };//var(--Neutral-White-000, #ffffff);
      const colorBlack: any = { r: 5, g: 5, b: 5 };//var(--Neutral-Grey-900, #050505);
      const colorCheckRgb: any = this.hexToRgb(colorCheck);

      // calcular la luminancia relativa
      const colorWhiteLuminance: any = this.luminance(colorWhite);
      const colorBlackLuminance: any = this.luminance(colorBlack);
      const colorCheckLuminance: any = this.luminance(colorCheckRgb);

      // calculate the color contrast ratio
      const ratioWhite: any = colorCheckLuminance > colorWhiteLuminance
        ? ((colorWhiteLuminance + 0.05) / (colorCheckLuminance + 0.05))
        : ((colorCheckLuminance + 0.05) / (colorWhiteLuminance + 0.05));
      const ratioBlack: any = colorCheckLuminance > colorBlackLuminance
        ? ((colorBlackLuminance + 0.05) / (colorCheckLuminance + 0.05))
        : ((colorCheckLuminance + 0.05) / (colorBlackLuminance + 0.05));
      let ratio: string = ratioBlack > ratioWhite?'white':'black';
      return ratio;
    }

    // hexToRgb(hexColor: any){
    //   // let red = parseInt(hexColor[1]+hexColor[2],16);
    //   // let green = parseInt(hexColor[3]+hexColor[4],16);
    //   // let blue = parseInt(hexColor[5]+hexColor[6],16);
    //   // return red+','+green+','+blue;
    //   return {
    //     r: parseInt(hexColor[1]+hexColor[2],16),
    //     g: parseInt(hexColor[3]+hexColor[4],16),
    //     b: parseInt(hexColor[5]+hexColor[6],16)
    //   };
    // }

    hexToRgb(hex: any) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m: any, r: any, g: any, b: any) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }

    luminance(rgbColor: any) {
      var a = [rgbColor.r, rgbColor.g, rgbColor.b].map(function (v) {
        v /= 255;
        return v <= 0.03928
          ? v / 12.92
        : Math.pow( (v + 0.055) / 1.055, 2.4 );
      });
      return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }

    configureSelectedTimeUnit(type: any, list: any, indexAdditional: any=0){
      switch(type){
          case 'd':
          case 'D':
              return list[0+indexAdditional];
          case 'w':
          case 'W':
              return list[1+indexAdditional];
          case 'm':
          case 'M':
              return list[2+indexAdditional];
          case 'y':
          case 'Y':
              return list[3+indexAdditional];
          case 'h':
          case 'H':
              return list[0];
          default:
              return type;
      }
    }

    checkAndDeletePreTag(description:string){
      if(description.indexOf('<pre')=== 0){
        let descriptionText:string =  description.replace('<pre', '<p');
        return descriptionText.substring(0, descriptionText.length-3)+'>';
      }else{
        return description;
      }

    }
    limitTo(list:any, begin:number, limitTo:number){
      return list.splice(begin, limitTo+begin)
    }

    getProductPermissions(productId:any, apiService:any){
      return new Promise((resolvePermissions: any, reject: any) => {
          try{
            apiService.get('company/dashboard/security/product', productId)
              .then((data:any)=> {
                this.userPermisions.setUserPermisions(data);
                resolvePermissions(data);
              }, (errorData:any)=>{reject()})
          }catch(errorData){
            reject();
          }
      });

    }
    isIE(){
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        let trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            let rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        let edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        return false;
    }

    clipboardText(text: any=''){
      navigator.clipboard.writeText(text).then(() => {}, () => {});
    }

    getFileExtension(extension: any){
      switch (extension) {
          case 'doc':
          case 'docx':
          case 'docm':
          case 'dot':
          case 'dotx':
          case 'dotm':
          case 'odt':
          case 'rtf':
              return 'lf-icon-word-software';
          case 'xls':
          case 'xlsx':
          case 'xlm':
          case 'xlsm':
          case 'xlt':
          case 'xltx':
          case 'xltm':
          case 'xlsb':
          case 'xlam':
          case 'xlv':
          case 'csv':
          case 'ods':
              return 'lf-icon-excel-software'
          case 'bmp':
          case 'gif':
          case 'dib':
          case 'jpg':
          case 'jpeg':
          case 'png':
          case 'tga':
          case 'tif':
          case 'tiff':
          case 'pcx':
          case 'pic':
          case 'emf':
          case 'ico':
          //internet
          case 'htm':
          case 'html':
          case 'css':
          case 'url':
          case 'xml':
          case 'eml':
          case 'msg':
          //audio
          case 'wav':
          case 'mp3':
          //video
          case 'avi':
          case 'mp4':
          case 'mov':
          case 'mpeg':
          case 'mpg':
          case 'divx':
          case 'wmv':
          case 'flv':
          case 'mkv':
          //comprimidos
          case 'rar':
          case 'zip':
          case '7z':
          //access
          case 'mdb':
          //texto
          case 'txt':
          case 'pdf':
          case 'wri':
          case 'log':
          case 'xps':
              return 'hide-icon';
          default:
              return 'lf-icon-powerpoint-software';
      }
    }


    searchInUrl(type:string){
        let word: any = location.search.substring(location.search.indexOf(type)+(type).length + 1);
        if(word){
          // word = word.replace('%3d', '=')
          let textSearch = word.indexOf('%3D') !== -1? '%3D':word.indexOf('%3d') !== -1?'%3d':'';
          return type ==='access'?(word).substring(0, (word).indexOf(textSearch)) : (word).substring(4, (word).indexOf(textSearch))
        }else{
          return false;
        }
    }

    findByWord(items: any, find: any, words: any){
        let filtered: any = [];
        if(items && items.length){
            items.forEach((item: any)=> {
              if(find !==''){
                  loopWords:
                  for(let i=0; i < words.length; i++){
                      let word = words[i];
                      let characters: any={
                          "á":"a", "é":"e", "í":"i", "ó":"o", "ú":"u",
                          "à":"a", "è":"e", "ì":"i", "ò":"o", "ù":"u", "ñ":"n",
                          "Á":"A", "É":"E", "Í":"I", "Ó":"O", "Ú":"U",
                          "À":"A", "È":"E", "Ì":"I", "Ò":"O", "Ù":"U", "Ñ":"N"}
                      let regExpCharacters=/[áàéèíìóòúùñ]/ig;
                      if(typeof word === 'object' && word !== null){
                        let wordArray = Object.keys(word);
                        for(let j=0; j < wordArray.length; j++){
                          for(let m=0; m < word[wordArray[j]].length; m++){
                            let wordChildren = word[wordArray[j]][m];
                            if(item[wordArray[j]]?.length){
                              for(let k=0; k < item[wordArray[j]].length; k++){
                                let itemChildren = item[wordArray[j]][k];
                                if(itemChildren[wordChildren] === null || !itemChildren[wordChildren]){
                                    itemChildren[wordChildren] = '';
                                }
                                let itemWord = itemChildren[wordChildren].toString();
                                let textWithoutAccent= itemWord.replace(regExpCharacters,(e:any)=>{return characters[e]});
                                let findWithoutAccent=find.replace(regExpCharacters,(e: any)=>{return characters[e]});
                                if(textWithoutAccent.toLowerCase().indexOf(findWithoutAccent.toLowerCase()) !== -1){
                                    filtered.push(item);
                                    break loopWords;
                                }
                              }
                            }
                          }
                        }
                      }else{
                        if(item[word] === null || !item[word]){
                            item[word] = '';
                        }

                        let itemWord = item[word].toString();
                        let textWithoutAccent= itemWord.replace(regExpCharacters,(e:any)=>{return characters[e]});
                        let findWithoutAccent=find.replace(regExpCharacters,(e: any)=>{return characters[e]});
                        if(textWithoutAccent.toLowerCase().indexOf(findWithoutAccent.toLowerCase()) !== -1){
                            filtered.push(item);
                            break;
                        }
                      }

                  }
              }else{
                  filtered.push(item);
              }
            });
        }
        return filtered;
    }

    paintNewItemArray(items: any){
        let filtered: any = [];
        if(items && items.length){
            items.forEach((item: any)=> {
              filtered.push(item);
            });
        }
        return filtered;
    }

  configureFooterVersion(){
    let  year: any = moment().format('YYYY');
    let configuration: any = {};
    switch(this.globalCfg.skin){
      case 'steel-blue':
        let links = this.configureFooterLinks();
        configuration = {
          companyInfo:  '©'+ year + ' Larcier Intersentia. · ',
          legalInfoLinks: [
            { id: 1,
              name: this.translate.instant('compliance-footer.general-terms'),
              href: links.generalTerms
            },
            { id: 2,
              name: this.translate.instant('compliance-footer.privacy'),
              href: links.privacy
            },
            { id: 3,
              name: this.translate.instant('compliance-footer.cookies'),
              href: links.cookies
            },
            { id: 4,
              name: this.translate.instant('compliance-footer.processing-personal-data'),
              href: links.processingPersonalData
            },
          ],
          separator: ' · '
        };
        break;
      case 'uk-steel-blue':
        configuration = {
          companyInfo:  this.translate.instant('compliance-footer.title-footer-uk') +  year + ' · ',
          legalInfoLinks: [
            { id: 1,
              name: this.translate.instant('compliance-footer.privacy-policy'),
              href: 'https://www.indicator-flm.co.uk/en/privacy/'
            },
            { id: 2,
              name: this.translate.instant('compliance-footer.terms-conditions'),
              href: 'https://www.indicator-flm.co.uk/en/terms/'
            },
          ],
          separator: ' · '
        };
        break;
      case 'icam-red':
        configuration = {
          legalInfoLinks: [
            { id: 1,
              name: this.translate.instant('compliance-footer.legal-warning'),
              href: 'https://www.otrosi.net/aviso-legal'
            },
            { id: 2,
              name: this.translate.instant('compliance-footer.cookies-policy'),
              href: 'https://www.otrosi.net/politica-de-cookies'
            }
          ],
          separator: ' · ',
          rrss: [
            {key: 'facebook', url: 'https://www.facebook.com/IlustreColegioAbogadosMadrid'},
            {key: 'linkedin', url: 'https://es.linkedin.com/company/ilustrecolegiodeabogadosdemadrid'},
            {key: 'twitter', url: 'https://twitter.com/icam_es'},
            {key: 'instagram', url: 'https://www.instagram.com/icam_es/'}
          ]
        }
        break;
      case 'gm-law':
        configuration = {
          companyInfo: '© Giuffrè Francis Lefebvre S.p.A. - Capitale Sociale € 2.000.000 i.v. - Sede legale: via Monte Rosa, 91 - 20149 Milano P.IVA 00829840156 | Società a socio unico. Società soggetta alla direzione e coordinamento di Lefebvre Sarrut Société Anonyme | ' ,
          legalInfoLinks: [
            { id: 1,
              name: this.translate.instant('compliance-footer.privacy-policy'),
              href: 'https://swift.it-mil2.entercloudsuite.com/v1/KEY_44f2d0920f254271a50851d48ed28f01/whistleblowing/Informativa%20privacy_GFL_%20whistelblowing.htm'
            },
            { id: 2,
              name: this.translate.instant('compliance-footer.cookies-policy'),
              href: 'https://swift.it-mil2.entercloudsuite.com/v1/KEY_44f2d0920f254271a50851d48ed28f01/whistleblowing/Privacy%20Policy%20Segnala.htm'
            },
          ],
          separator: ' | ',
          rrss: [
            {key: 'facebook', url: 'https://www.facebook.com/GiuffreFrancisLefebvre/'},
            {key: 'linkedin', url: 'https://www.linkedin.com/company/giuffr%C3%A8francislefebvre/'},
            {key: 'instagram', url: 'https://www.instagram.com/giuffre.francis.lefebvre'}
          ]
        }
        break;
      default:
        configuration = {
          companyInfo:  '©Lefebvre '+  year + '. ' + this.translate.instant('compliance-footer.reserved-rights') + ' ',
          legalInfoLinks: [
            { id: 1,
              name: this.translate.instant('compliance-footer.legal-warning'),
              href: 'https://lefebvre.es/aviso-legal'
            },
            { id: 2,
              name: this.translate.instant('compliance-footer.privacy-policy'),
              href: 'https://lefebvre.es/politica-privacidad'
            },
            { id: 3,
              name: this.translate.instant('compliance-footer.cookies-policy'),
              href: 'https://lefebvre.es/politica-de-cookies'
            }
          ],
          separator: ' · ',
          rrss: [
            {key: 'linkedin', url: 'https://www.linkedin.com/company/lefebvre_es'},
            {key: 'youtube', url: 'https://www.youtube.com/c/lefebvre_es'},
            {key: 'facebook', url: 'https://www.facebook.com/Lefebvre.ES/'},
            {key: 'twitter', url: 'https://twitter.com/Lefebvre_ES'},
            {key: 'instagram', url: 'https://www.instagram.com/lefebvre_es/'}
          ]
        }
        break;
    }
    configuration.logo = this.configureLogoFooter();
    return configuration;
  }

  configureFooterLinks(){
    let language = sessionStorage.getItem('selectLanguage');
    let links = {
      generalTerms: '',
      cookies: '',
      privacy: '',
      processingPersonalData: ''
    }
    switch(language){
    // es-ES, en-US, en-GB, fr-FR, fr-BE, nl-NL, nl-BE
      case 'fr-FR':
      case 'fr-BE':
        links.generalTerms = "https://cdn.lefebvre-sarrut.be/terms/fr.pdf";
        links.cookies ="https://cdn.lefebvre-sarrut.be/privacy/LSB/cookie_policy_FR.pdf ";
        links.privacy = "https://cdn.lefebvre-sarrut.be/privacy/LSB/charte-vie-privee.pdf ";
        links.processingPersonalData = "https://cdn.lefebvre-sarrut.be/privacy/LSB/Traitement-donnees-Electronic-products.pdf";
        break;
      case 'nl-NL':
      case 'nl-BE':
        links.generalTerms = "https://cdn.lefebvre-sarrut.be/terms/nl.pdf";
        links.cookies ="https://cdn.lefebvre-sarrut.be/privacy/LSB/cookie_policy_NL.pdf ";
        links.privacy = "https://www.larcier.com/media/wysiwyg/pdf/legal-nl/privacy.pdf ";
        links.processingPersonalData = "https://cdn.lefebvre-sarrut.be/privacy/LSB/Gegevensverwerking-Electronic-products.pdf";
        break;
      default:
        links.generalTerms = "https://cdn.lefebvre-sarrut.be/terms/en.pdf";
        links.cookies ="https://cdn.lefebvre-sarrut.be/privacy/LSB/cookie_policy_EN.pdf";
        links.privacy = "https://cdn.lefebvre-sarrut.be/privacy/LSB/privacy_EN.pdf";
        links.processingPersonalData = "https://cdn.lefebvre-sarrut.be/privacy/LSB/Dataprocessing-Electronic-products.pdf";
        break;
    }
    return links;
  }

  configureLogoFooter(){
    let isLanding: Boolean = this.customLanding.isLanding();
    switch(this.globalCfg.skin){
      case 'steel-blue':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/logo-larcier-intersentia-268x55.png':'https://assets.lefebvre.es/media/logos/web/clientes/logo-larcier-intersentia40.png';
      case 'uk-steel-blue':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/logo-indicator-flm-289x55.png':'https://assets.lefebvre.es/media/logos/web/clientes/logo-indicator-flm-40.png';
      case 'icam-red':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/logo-icam-gestion-conocimiento-263x55.png':'https://assets.lefebvre.es/media/logos/web/clientes/logo-icam-gestion-conocimiento-40.png';
      case 'gm-law':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/logo-giuffre-francis-lefebvre-320x25.png':'https://assets.lefebvre.es/media/logos/web/clientes/logo-giuffre-francis-lefebvre-25.png';
      default:
        return isLanding?'https://assets.lefebvre.es/media/logos/web/comunes/lefebvre-277x55.png':'https://assets.lefebvre.es/media/logos/web/comunes/lefebvre-202x40.png';
    }
  }

  configureLogoHeader(){
    let isLanding: Boolean = this.customLanding.isLanding();
    switch(this.globalCfg.skin){
      case 'steel-blue':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/belgica-gocomply-176x45.png':'https://assets.lefebvre.es/media/logos/web/clientes/belgica-gocomply-38.png';
      case 'uk-steel-blue':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/uk-taxwin-158x45.png':'https://assets.lefebvre.es/media/logos/web/clientes/uk-taxwin-38.png';
      case 'icam-red':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/icam-centinela-119x45.png':'https://assets.lefebvre.es/media/logos/web/clientes/icam-centinela-54.png';
      case 'gm-law':
        return isLanding?'https://assets.lefebvre.es/media/logos/web/clientes/italia-segnala-260x35.png':'https://assets.lefebvre.es/media/logos/web/clientes/italia-segnala-38.png';
      default:
        return isLanding?'https://assets.lefebvre.es/media/logos/web/comunes/lefebvre-centinela-186x45.png':'https://assets.lefebvre.es/media/logos/web/comunes/lefebvre-centinela-38.png';
    }
  }

  configureLogoLogin(){
    switch(this.globalCfg.skin){
      case 'steel-blue':
        return 'https://assets.lefebvre.es/media/logos/web/clientes/belgica-gocomply-196x50.png';
      case 'uk-steel-blue':
        return 'https://assets.lefebvre.es/media/logos/web/clientes/uk-taxwin-176x50.png';
      case 'icam-red':
        return 'https://assets.lefebvre.es/media/logos/web/clientes/icam-centinela-132x50.png';
      case 'gm-law':
        return 'https://assets.lefebvre.es/media/logos/web/clientes/italia-segnala-290x40.png';
      default:
        return 'https://assets.lefebvre.es/media/logos/web/comunes/lefebvre-centinela-207x50.png';
    }
  }

  splitString(value:any){
    return value.indexOf('|') === -1? [value] : value.split('|')
  }

  goToStateUrl(){
    let url = this.stateManagement.getLastState();
    url!==''?this.router.navigate([url]):this.router.navigate(['dashboard']);
    this.stateManagement.removeLastStateUrl();
  }

  toNgbCalendar(date:any){
    return {
        month: parseInt(moment(date).format('M')),
        day: parseInt(moment(date).format('D')),
        year: parseInt(moment(date).format('YYYY'))
    }
  }

  ngbToMoment(date:any){
    let day:any = date.day < 10? '0' + date.day : date.day;
    let month:any = date.month < 10? '0' + date.month : date.month;
    return moment(date.year+'-'+month+'-'+day);
  }

  checkResponsibles(responsibles:any, userId:any){
    for(let i = 0; i < responsibles.length; i++){
        if(responsibles[i].id === userId){
            return false;
        }
    }
    return true;
  }

  configureTaskResponsibleList(list: any){
    let responsiblesUniqueList:any = [];
    let responsiblesMap = new Map();
    list.forEach((taskProcess:any, index:any) => {
      taskProcess.responsibles.forEach((responsible:any) => {
        let uniqueId = responsible.type+'-'+responsible.id;
        if(!responsiblesMap.has(uniqueId)){
            responsiblesMap.set(uniqueId, index);
            responsible.uniqueId = uniqueId;
            responsiblesUniqueList.push(responsible);
        }
      });
    });
    return responsiblesUniqueList;
  }

  checkIsHexadecimalColor(color: any=''){
    let regExpHex =new RegExp('^#[0-9A-Fa-f]{6}$', 'i');
    // let regExpHex = /^#[0-9A-F]{6}$/i;
    // let regExpHex3Values = /^#([0-9A-F]{3}){1,2}$/i; //Para comprobar si tiene o 3 o 6
    return regExpHex.test(color);
  }

  locationSearchParam(param:any){
    new URL(location.href).searchParams.get(param)
    const params = new URL(location.href).searchParams;
    return params.get(param) === null? '' : params.get(param) ;
  }

  reloadNavigateUrlEvaluation(newPathName: any, evaluationId: any=undefined){
    let evaluationUrl: string = evaluationId?'evaluation/'+evaluationId+'/redirect':'evaluation';
    this.router.navigateByUrl(evaluationUrl, { skipLocationChange: true  }).then(() => {
        this.router.navigate([newPathName]);
    });
  }
  searchFormu(fieldContainers:any, concept: any){
    fieldContainers.forEach((fieldContainer:any) => {
      fieldContainer.active = concept.groupsAsList;
      let hasFormu: number = 0;
      fieldContainer.fields.forEach((field:any) => {
        if(this.itsFormu(field)){
          field.itsFormu = true;
          hasFormu++;
        }
      });
      fieldContainer.subContainers.forEach((subContainer:any) => {
        let subHasFormu: number = 0;
        subContainer.fields.forEach((subField:any)=>{
          if(this.itsFormu(subField)){
            subField.itsFormu = true;
            subHasFormu++;
            hasFormu++;
          }
        })
        subContainer.hasFormu = Boolean(subHasFormu);
      });
      fieldContainer.hasFormu = Boolean(hasFormu);
    });
    return fieldContainers;
  }

  itsFormu(field:any){
    return field.fieldTypeId === 'formu' || field.fieldTypeId === 'formp' || field.fieldTypeId === 'agreg' || field.fieldTypeId === 'agrep' || field.fieldTypeId === 'score';
  }

  OnDestroy(subscribers : any ){
    for (let key in subscribers) {
      subscribers[key].unsubscribe();
    }
  }

  uniqueValuesList(list:any, type:string){
    let keys: any = [];
    let uniqueList: any = [];
    if(list){
      list.forEach((item:any) => {
        let key:any = item[type];
        if (keys.indexOf(key) === -1) {
            keys.push(key);
            uniqueList.push(item);
        }
      });
    }
    return uniqueList;
  }

  clickShowToolip(elementTooltip: any, type: any, time:number=1000){
    elementTooltip[type].showTooltip = true;
    setTimeout(()=>{
      elementTooltip.tooltip.show();
    }, 100)
    setTimeout(()=>{
      elementTooltip.tooltip.hide();
      elementTooltip[type].showTooltip = false;;
    }, time)
  }

  getSvgIcon(item:any, type:string){
    switch(item.toLowerCase()){
      case 'doc':
      case 'docx':
      case 'docm':
      case 'dot':
      case 'dotx':
      case 'dotm':
      case 'rtf':
      case 'odt':
        return 'lf-icon-svg-word-'+type;
      case 'xls':
      case 'xlsx':
      case 'xlm':
      case 'xlsm':
      case 'xlt':
      case 'xltx':
      case 'xltm':
      case 'xlsb':
      case 'xlam':
      case 'xlv':
      case 'ods':
      case 'csv':
        return 'lf-icon-svg-excel-'+type;
      case 'ppt':
      case 'pptx':
      case 'pptm':
      case 'pot':
      case 'potx':
      case 'potm':
      case 'ppa':
      case 'ppam':
      case 'pps':
      case 'ppsx':
      case 'ppsm':
      case 'sldx':
      case 'sldm':
      case 'thmx':
      case 'odp':
        return 'lf-icon-svg-power-point-'+type;
      case 'pdf':
        return 'lf-icon-svg-pdf-'+type;
      case 'bmp':
      case 'gif':
      case 'dib':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'tga':
      case 'tif':
      case 'tiff':
      case 'pcx':
      case 'pic':
      case 'emf':
      case 'ico':
        return 'lf-icon-svg-image-'+type;
      case 'wav':
      case 'mp3':
      case 'avi':
      case 'mp4':
      case 'mov':
      case 'mpeg':
      case 'mpg':
      case 'divx':
      case 'wmv':
      case 'flv':
      case 'mkv':
        return 'lf-icon-svg-video-'+type;
      case 'eml':
      case 'msg':
        return 'lf-icon-svg-mail-text-'+type;
      case 'zip':
        return 'lf-icon-svg-zip-'+type;
      case 'rar':
      case '7z':
        return 'lf-icon-svg-folder-zip-'+type;
      case 'htm':
      case 'html':
      // case 'css':
      // case 'url':
      // case 'xml':
        return 'lf-icon-svg-html-'+type;
      case 'mdb':
        return 'lf-icon-svg-access-'+type;
      case 'folder':
        return 'lf-icon-svg-folder-'+type;
      default:
        return 'lf-icon-svg-document-'+type;
    }
  }

  configCalendar(){
    let dayNames: any = this.translate.instant('calendar.dayNames');
    let dayNamesShort: any = this.translate.instant('calendar.dayNamesShort');
    //let dayNamesMin: any = this.translate.instant('calendar.dayNamesShort');
    let monthNames: any = this.translate.instant('calendar.monthNames');
    let monthNamesShort: any = this.translate.instant('calendar.monthNamesShort');

    this.primeConfig.setTranslation({
      dayNames:	dayNames,
      dayNamesShort: dayNamesShort,
      dayNamesMin: dayNamesShort,
      monthNames:	monthNames,
      monthNamesShort: monthNamesShort
    });
  }

  bindScrollOverlayListener(overlayPanel: any, type:any='overlay'){
    if (overlayPanel) {
      overlayPanel.bindScrollListener = () => {
        overlayPanel.scrollHandler = new ConnectedOverlayScrollHandler(overlayPanel.target, ( e:any) => {
          if(type === 'menu' && e.target.id === 'centinela-app-template'){
            overlayPanel.alignOverlay();
          }else if(e.target.id === 'centinela-app-template' && type !== 'overlayInner'){
            overlayPanel.align();
          }else{
            overlayPanel.hide();
          }
        });
        overlayPanel.scrollHandler.bindScrollListener();
      };
    }
  }

  toggleFilterOverlay(e: any, overlayPanel: any, type: any='overlay', nativeElement: any=undefined){
    let dropdownOpen: any = this.dropdownsOpenFactory.getDropdown();
    let overlayVisible: any = type === 'menu'?overlayPanel.visible:overlayPanel.overlayVisible;
    // if (dropdownOpen && dropdownOpen.el.nativeElement.id !== overlayPanel.el.nativeElement.id) {
    if (dropdownOpen && !overlayVisible && type !== 'overlayInner') {
      this.dropdownsOpenFactory.closeDropdown();
    }
    if (overlayVisible) {
      type === 'overlayInner'? this.dropdownsOpenFactory.closeLastDropdown() : this.dropdownsOpenFactory.closeDropdown();
    } else {
      overlayPanel.show(e, nativeElement);
      this.dropdownsOpenFactory.addDropdown(overlayPanel);
    }
  }

  checkCustomizeFieldInFormula(field:any, container: any, typeDelete:string){
    let fieldInFormula : any = this.searchFieldInFormu(container, field, typeDelete);
    return fieldInFormula;
  }

  searchFieldInFormu(containers:any, fieldSelected:any, typeDelete: string){
    for(let containerSelected of containers){
      for(let field of containerSelected.fields){
        if(field.fieldTypeId === 'formu' && (field.formula && field.formula.indexOf(parseInt(fieldSelected.fieldId))!==-1) && (typeDelete === 'field' || (typeDelete === 'group' && field.fieldContainerId !== fieldSelected.fieldContainerId))){
          return true;
        }
      }
      if(containerSelected.subContainers && containerSelected.subContainers.length){
        this.searchFieldInFormu(containerSelected.subContainers, fieldSelected, typeDelete);
      }
    }
    return false;
  }

  configureCustomizeFieldAttributes(field: any){
    if(!field.fieldAttributes){
      field.fieldAttributes = {};
    }
    field.fieldAttributes.private = field.private;
    field.fieldAttributes.fieldNotInForce = field.fieldNotInForce;
    field.fieldAttributes.hiddenInLandings = field.hiddenInLandings;
    field.fieldAttributes.isDisaggregated = field.isDisaggregated;
    field.fieldAttributes.nullsAsZero = field.nullsAsZero;
    if(field.fieldTypeId ==='text' && field.multiline){
      field.fieldAttributes.isVoiceRecord = field.isVoiceRecord;
      field.fieldAttributes.voiceRecordOkText = field.voiceRecordOkText;
    }
    if (field.fieldTypeId === 'date') {
      field.fieldAttributes.dateLockType = field.dateLockType;
    }
    if (field.fieldTypeId === 'rich') {
      field.fieldAttributes.isEditable = field.isEditable;
    }
    if (field.fieldTypeId === 'l-co') {
      field.fieldAttributes.lcoIsUngroupedView = field.lcoIsUngroupedView;
    }
    if (field.fieldTypeId === 'boolp') {
      field.listValues[0].weight = field.weightYes;
      field.listValues[1].weight = field.weightNo;
    }
    if (field.fieldTypeId === 'list' || field.fieldTypeId === 'listp'){
      field.listValues.forEach((listValue: any) => {
        if(listValue.newItem){
          delete listValue.listValueId;
          delete listValue.newItem;
        }
        if(!field.isHighlight){
          delete listValue.color;
        }
      });
    }
  }

  configureFieldEidtable(configurationOptions:any){
    let fieldContainer: any = configurationOptions.fieldContainer;
    let parentContainer: any = this.getParentContainer(fieldContainer,  configurationOptions.concept.fieldContainers);
    let newField: any = cloneDeep(configurationOptions.field);
    newField.open = true;
    let configuration: any = {
      field: newField,
      actionType: configurationOptions.actionType,
      concept: configurationOptions.concept,
      fieldContainer: fieldContainer,
      parentContainer: parentContainer,
      isPrivate: parentContainer?.private || fieldContainer.private,
      hiddenInLandings: parentContainer?.hiddenInLandings || fieldContainer.hiddenInLandings,
      isMultiple: parentContainer && fieldContainer.multiple,
      visibilityItems: configurationOptions.visibilityItems
    }
    return configuration;
  }

  getParentContainer(fieldContainer: any, containers: any){
    if(fieldContainer.parentId){
      for (let i = 0; i < containers.length; i++) {
        if(containers[i].fieldContainerId === fieldContainer.parentId){
          return containers[i];
        }
      }
    }
    return null;
  }

  setEncodingDisplayText(encodingItem:any) {
    let displayText : any = null;
    if (encodingItem.operator1) {
        displayText = encodingItem.operator1 + ' ' + encodingItem.value1;
        if (encodingItem.operator2) {
            displayText += ' ' + this.translate.instant('common.and') + ' ' + encodingItem.operator2 + ' ' + encodingItem.value2;
        }
        displayText += ' = ' + encodingItem.text;
    }
    encodingItem.displayText = displayText;
  }

  findEvaluatedValue(evaluatedList:any, field:any, numSubContainer:any){
    return evaluatedList.filter((evaluatedItem:any)=>{return evaluatedItem.fieldId === field.fieldId && evaluatedItem.numSubContainer === numSubContainer})[0]
  }

  configurePaletteColors(data: any){
    let root: any = document.querySelector(':root');
    let rootStyles: any = getComputedStyle(root);
    let palette = [
      '--Data-Lilac-200',
      '--Data-MarianBlue-200',
      '--Data-TiffanyBlue-200',
      '--Data-Dun-200',
      '--Data-Ecru-200',
      '--Data-Citron-200',
      '--Data-CastletonGreen-200',
      '--Data-Pear-200',
      '--Data-SlateGrey-200',
      '--Data-AmaranthPurple-200',
      '--Data-Murrey-200',
      '--Data-AmaranthPink-200'
    ]
    if(data.length > 12){
      let additionalColors = [
        '--Data-AmaranthPink-100',
        '--Data-AmaranthPink-300',
        '--Data-AmaranthPink-400',
        '--Data-AmaranthPurple-100',
        '--Data-CastletonGreen-100',
        '--Data-CastletonGreen-300',
        '--Data-CastletonGreen-400',
        '--Data-Citron-100',
        '--Data-Citron-300',
        '--Data-Citron-400',
        '--Data-Dun-100',
        '--Data-Dun-300',
        '--Data-Dun-400',
        '--Data-Ecru-100',
        '--Data-Ecru-300',
        '--Data-Ecru-400',
        '--Data-Lilac-100',
        '--Data-Lilac-300',
        '--Data-Lilac-400',
        '--Data-MarianBlue-100',
        '--Data-MarianBlue-300',
        '--Data-MarianBlue-400',
        '--Data-Murrey-100',
        '--Data-Pear-100',
        '--Data-Pear-300',
        '--Data-Pear-400',
        '--Data-SlateGrey-100',
        '--Data-SlateGrey-300',
        '--Data-SlateGrey-400',
        '--Data-TiffanyBlue-100',
        '--Data-TiffanyBlue-300',
        '--Data-TiffanyBlue-400',
        '--Data-Murrey-400',
        '--Data-Murrey-300',
        '--Data-Murrey-200',
        '--Data-Murrey-100'
      ]
      palette = palette.concat(additionalColors);
    }
    let newPalette: any = [];
    palette.forEach((colorPalete: any) => {
      newPalette.push(rootStyles.getPropertyValue(colorPalete));
    });
    let randomPalette = newPalette.sort(function() { return Math.random() - 0.5 });
    return randomPalette;
  }

  checkConceptWithIA(fieldcontainers:any){
    for(let i=0; i < fieldcontainers.length; i++){
      let fieldContainer = fieldcontainers[i];
      for(let j=0; j < fieldContainer.fields.length; j++){
        let field = fieldContainer.fields[j];
        if(field.ia){
          return true;
        }
      }
      for(let k=0; k < fieldContainer.subContainers.length; k++){
        let subContainer = fieldContainer.subContainers[k];
        for(let l=0; l < subContainer.fields.length; l++){
          let subfield = subContainer.fields[l];
          if(subfield.ia){
            return true;
          }
        }
      }
    }
    return false;
  }

  updateTextTooltip(tooltip: any, textTooltip: any){
    tooltip.content = textTooltip;
    tooltip.ngOnChanges({
      content: {
        currentValue: tooltip.content,
        previousValue: null,
        firstChange: false,
        isFirstChange: () => false
      }
    });
  }

}
